import React from 'react';
import ChatBot from './components/ChatBot/ChatBot';
import LayoutPrivate from './components/Layout/Private/LayoutPrivate';
import LayoutPublic from './components/Layout/Public/LayoutPublic';
import PrivateRoutes from './components/Routes/PrivateRoutes';
import PublicRoutes from './components/Routes/PublicRoutes';
import WebConfig from './components/WebConfig/WebConfig';

export default function Layout({ isUserLoggedIn, showExtendedFooter, isPasswordExpired, onNavBarSelect, hideBrand, tagline, onWebChatButtonClick }) {
    if (!isUserLoggedIn || isPasswordExpired) {
        return (
            <LayoutPublic showExtendedFooter={showExtendedFooter} hideBrand={hideBrand} tagline={tagline}>
                <PublicRoutes isPasswordExpired={isPasswordExpired} />
            </LayoutPublic>
        );
    } else {
        return (
            <LayoutPrivate
                onNavBarSelect={onNavBarSelect}
                showExtendedFooter={showExtendedFooter}
                onWebChatButtonClick={onWebChatButtonClick}
                hideBrand={hideBrand}
            >
                <PrivateRoutes disableUserProfile={hideBrand} />
                <WebConfig />
                <ChatBot></ChatBot>

            </LayoutPrivate>
        );
    }
}
